import WorkflowCard from './WorkflowCard'
import type { WorkflowCardData } from '@/data/modalityWorkflows'

interface WorkflowGridProps {
  title: string
  workflows: WorkflowCardData[]
  max?: number
}

export default function WorkflowGrid({ title, workflows, max }: WorkflowGridProps) {
  return (
    <div className="mt-8">
      <hr className="my-6 bg-purple-100" />
      <h4 className="text-lg font-semibold text-black mb-4">{title}</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {workflows.slice(0, max).map((workflow) => (
          <WorkflowCard key={workflow.id} workflow={workflow} />
        ))}
      </div>
    </div>
  )
}